import { TableItemContainer } from 'components/shared';
import React from 'react';

/**
 * @function NoWireTransferTableRow
 * @param {String} colspan - allows us to set how many rows the table data will span
 * @return {React.Component}
 * @exported true
 * @description The table row that shows no wire transfers
 */

export default function NoWireTransferTableRow(props){
  const colspan = props.colspan ?? "1";

  return(
    <TableItemContainer className="no-wire-transfer-table-row">
      <td colSpan={colspan} className="text-center table-item-text-view">There are no wire transfers to display</td>
    </TableItemContainer>
  );
}